import he from "he";
import type { SnipeItAsset, SnipeItConsumable } from "./types";

/** Recursively decodes HTML entities in `name` fields. */
function decodeName<T extends { name: string }>(obj: T): T {
  return { ...obj, name: he.decode(obj.name) };
}

/** Decodes all HTML-encoded name fields on an asset and its nested objects. */
export function decodeAsset(asset: SnipeItAsset): SnipeItAsset {
  return {
    ...asset,
    name: he.decode(asset.name),
    model: asset.model ? decodeName(asset.model) : asset.model,
    category: asset.category ? decodeName(asset.category) : asset.category,
    manufacturer: asset.manufacturer ? decodeName(asset.manufacturer) : asset.manufacturer,
    status_label: asset.status_label ? decodeName(asset.status_label) : asset.status_label,
    location: asset.location ? decodeName(asset.location) : asset.location,
    rtd_location: asset.rtd_location ? decodeName(asset.rtd_location) : asset.rtd_location,
    assigned_to: asset.assigned_to ? decodeName(asset.assigned_to) : asset.assigned_to,
  };
}

/** Decodes HTML-encoded name fields on a consumable. */
export function decodeConsumable(consumable: SnipeItConsumable): SnipeItConsumable {
  return {
    ...consumable,
    name: he.decode(consumable.name),
    category: consumable.category ? decodeName(consumable.category) : consumable.category,
  };
}
